import moment from 'moment';
import { getFetchHeaders } from '../getFetchHeaders';
import { getFetchResponseData } from '../getFetchResponseData';
import * as actions from './types';

export const actionCreators = {
  getTimeBucketCategories: () => {
    return async (dispatch) => {
      try {
        dispatch({ type: actions.GET_TIME_BUCKET_CATEGORIES });
        var headers = await getFetchHeaders();
        var url = `api/v2/TimeTracker/timeBucket/categories`;
        const response = await fetch(url, {
          method: 'GET',
          headers: headers,
        });
        const data = await getFetchResponseData(response);
        dispatch({
          type: actions.GET_TIME_BUCKET_CATEGORIES_SUCCESS,
          payload: { categories: data },
        });
      } catch (error) {
        //TODO: clean this up once done
        console.error('Error fetching time bucket categories:', error);
        dispatch({ type: actions.GET_TIME_BUCKET_CATEGORIES_FAILURE });
      }
    };
  },
  getTimeBucketEntriesForCategory: (oid, selectedDays, categoryId) => {
    return async (dispatch) => {
      try {
        dispatch({ type: actions.GET_TIME_BUCKET_ENTRIES_FOR_CATEGORY });

        const startDate = moment(selectedDays[0]).format('YYYY-MM-DD');
        const endDate = moment(selectedDays[6]).format('YYYY-MM-DD');

        var headers = await getFetchHeaders();
        var url = `api/v2/TimeTracker/timeBucket/categories/${categoryId}/entries?UserId=${oid}&StartDate=${startDate}&EndDate=${endDate}`;
        const response = await fetch(url, {
          method: 'GET',
          headers: headers,
        });

        const data = await getFetchResponseData(response);
        dispatch({
          type: actions.GET_TIME_BUCKET_ENTRIES_FOR_CATEGORY_SUCCESS,
          categoryId: categoryId,
          selectedDays: selectedDays,
          payload: { buckets: data },
        });

        return data;
      } catch (error) {
        console.error('Error fetching time bucket entries:', error);
        dispatch({
          type: actions.GET_TIME_BUCKET_ENTRIES_FOR_CATEGORY_FAILURE,
        });
      }
    };
  },
  getTimeBucketCalendarYearTotal: (userId, timeBucketId) => {
    return async (dispatch) => {
      try {
        dispatch({ type: actions.GET_TIME_BUCKET_CYT });

        var headers = await getFetchHeaders();
        var url = `api/v2/TimeTracker/timeBucket/${timeBucketId}/cyt?userId=${userId}`;
        const response = await fetch(url, {
          method: 'GET',
          headers: headers,
        });

        const data = await getFetchResponseData(response);
        dispatch({
          type: actions.GET_TIME_BUCKET_CYT_SUCCESS,
          timeBucketId: timeBucketId,
          payload: { calendarYearTotalHours: data },
        });

        return data;
      } catch (error) {
        console.error('Error fetching time bucket YTD:', error);
        dispatch({
          type: actions.GET_TIME_BUCKET_CYT_FAILURE,
          timeBucketId: timeBucketId,
        });
        throw error;
      }
    };
  },
  upsertTimeBucketTimeEntry: (userId, date, hours, timeBucketId) => {
    const tzOffset = new Date().getTimezoneOffset();

    return async () => {
      var headers = await getFetchHeaders();
      var url = 'api/v2/TimeTracker/timeBucket/entries/upsert';
      const response = await fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          timeBucketId: timeBucketId,
          date: date,
          userId: userId,
          hours: hours,
          timezone: tzOffset,
        }),
      });

      const data = await getFetchResponseData(response);

      return data;
    };
  },
  deleteTimeBucketTimeEntry: (id) => {
    return async () => {
      var headers = await getFetchHeaders();
      var url = `api/v2/TimeTracker/timeBucket/entries/${id}`;
      return fetch(url, {
        method: 'DELETE',
        headers: headers,
      });
    };
  },
  updateCategoriesToBeRefreshed: (newList) => {
    return (dispatch) => {
      dispatch({
        type: actions.UPDATE_CATEGORIES_TO_BE_REFRESHED,
        payload: newList,
      });
    };
  },
  removeFromCategoriesToBeRefreshed: (categoryId) => {
    return (dispatch) => {
      dispatch({
        type: actions.REMOVE_FROM_CATEGORIES_TO_BE_REFRESHED,
        payload: categoryId,
      });
    };
  },
};
